/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.25",
    versionName: "0.2.0-nightly.2026.1.25",
    versionChannel: "nightly",
    buildDate: "2026-01-25T00:09:04.007Z",
    commitHash: "fb996f8832bfdd8e6d7687a362778113ebef2c1d",
};
